// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mainInfoMarker{
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.mainInfoMarkerWhite{
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* border: 1px solid #003757; */
}
.contInfoMarker{
  display: block;
  position: relative;
  width: 98%;
  height: 98%;
}
.titleInfoMarker{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10%;
  max-height: 30px;
}

.bodyInfoMarker{
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:50%;
  
}
.actionsInfoMarker{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40%;
  
}
.txtTitleInfoMarker{
  font-size: var(--font-size-med);
  color: var(--main-color);
}
.txtTitleInfoMarkerWhite{
  font-size: medium;
  color: #003757;
}
.contHost{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50%;
}
.contCheck{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  height: 100%;
}
.contInfoHost{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  height: 100%;
}
.infoHost{
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60%;
  border: var(--border-table-color) 1px solid;
  border-radius: var(--border-radios-small);
}
.rowInfo {
  justify-content: center;
  position: relative;
  display: flex;
  overflow: hidden;
  height: 60%;
  /* background: #5d5c69; */
  background-color: var(--white-color);
  /* background-size: 400%; */
  color: var(--txt-color);
  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);
  width: 100%;
}
.rowInfoWhite {
  justify-content: center;
  position: relative;
  display: flex;
  overflow: hidden;
  height: 60%;
  /* background: #5d5c69; */
  background-color: #eeeeee;
  background-size: 400%;
  color: #003757;
  border-radius: 0px 0px 10px 10px;
  width: 100%;
}
.titlesInfo{
  height: 40%;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: var(--third-color);
  /* max-height: 25px; */
}
.titlesInfoWhite{
  height: 40%;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: #003757;
  /* max-height: 25px; */
}
.hostInfoCell{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.txtHostInfoCell{
  text-align: center;
  position: relative;
  width: 100%;
  height: auto;
  word-break: break-all;
  margin: 0 0 1em 1em;
  display: flex;
  font-size: var(--font-size-xSmall);
  letter-spacing: 0.5px;
  justify-content: center;
  margin: 2%;
}
.textWOA{
  font-size: var(--font-size-med);
  color: var(--txt-color-low);
}
.textWOAWhite{
  font-size: medium;
  color: #00375771;
  font-weight: unset !important;
}


/*************************************cont actions**************************************/
.txtHostSelected{
  position: absolute;
  display: flex;
  justify-content: center;
  /* align-items: center;
  width: 30%;
  height: 100%; */
  color: var(--main-color);
  font-size: var(--font-size-small);
  /* font-weight: bold; */
  left: 2%;
  top: 0;
  /* background-color: rgb(23, 24, 24); */
}
.txtHostSelectedWhite{
  position: absolute;
  display: flex;
  justify-content: center;
  /* align-items: center;
  width: 30%;
  height: 100%; */
  color: #003757;
  font-weight: bold;
  left: 0;
  top: 0;
  /* background-color: rgb(23, 24, 24); */
}
.contActionsInfoMarker{
  position: relative;
  display: block;
  width: 99%;
  height: 98%;
  /* border: #ffffff33 1px solid; */
}
.menu-actions{
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  width: 100%;
  height: 15%;
}
.compactactions-list{
  position: relative;
  display: flex;
  width: 30%;
  height: 100%;
  justify-content: center;
  align-items: center;
  justify-content: space-between; /* Distribuye el espacio entre los elementos */
list-style-type: none; /* Elimina los estilos de viñetas de la lista */
padding: 0; /* Elimina el relleno predeterminado de la lista */
margin: 0; 
}
.compactactions-listWhite{
  position: relative;
  display: flex;
  width: 30%;
  height: 100%;
  justify-content: center;
  align-items: center;
  justify-content: space-between; /* Distribuye el espacio entre los elementos */
list-style-type: none; /* Elimina los estilos de viñetas de la lista */
padding: 0; /* Elimina el relleno predeterminado de la lista */
margin: 0; 
}
.compactactions-list li {
  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
  width: 33%;
  height: 100%;
  background-color: transparent;
  border-right: 1px solid var(--border-table-color);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  cursor: pointer;
  /* color: rgba(195,195,195,1); */
  color: var(--txt-color);
}
.compactactions-listWhite li {
  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
  width: 33%;
  height: 100%;
  background-color: transparent;
  border-right: 1px solid #003757;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: small;
  cursor: pointer;
  /* color: rgba(195,195,195,1); */
  color: #003757;
}
.compactactions-listWhite li:hover{
  background-color: rgba(179, 179, 179, 0.534);
}
.action-selected{
  /* background-color: rgba(195,195,195,1) !important; */
  background-color: var(--third-color) !important;
  /* color: rgb(1, 17, 31) !important; */
  color:var(--white-color) !important;
}
.action-selectedWhite{
  /* background-color: rgba(195,195,195,1) !important; */
  background-color: #003757 !important;
  /* color: rgb(1, 17, 31) !important; */
  color:aliceblue !important;
}
.contActions{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 85%;
  border: var(--border-table-color) 1px solid;
  border-radius: var(--border-radios-small);
}
.contActionsWhite{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 85%;
  border: #003757 2px solid;
}
.contAcciones{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 80%;
}

.lblInfoHost{
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  color: aliceblue;
  margin-left: 1%;
}
.lblInfoHostWhite{
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  color: 003757;
  margin-left: 1%;
}
.menuActionDataIM {
  display: flex;
  flex-wrap: wrap;
  /* max-width: 400px;  */
  width: 95%;
  overflow-y: auto; /* Activar el scroll vertical cuando sea necesario */
  max-height: 95%;
  height: 85%;
}
.menuActionCellIM .compactAction{
  width: 90%;
  height: 70%;
  
}
.menuActionCellIM .menuActionOption{
  height: 90%;
}
.oneCell{
max-width: 150px;
height: 50%;
max-height: 50px;
}
.menuActionCellIM {
  /* border: unset; */
  border: 1px solid rgba(240, 248, 255, 0.105);
  width: 25%;
  box-sizing: border-box; /* Considerar el padding y borde en el ancho */
  /* min-height: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50%;
}
/******************************estilos de radiocheck************************************/
.checkHost {
  -webkit-appearance: none;
 /* remove default */
  display: block;
  margin: 10px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  cursor: pointer;
  vertical-align: middle;
  box-shadow: hsla(0,0%,100%,.15) 0 1px 1px, inset hsla(0,0%,0%,.5) 0 0 0 1px;
  background-color: hsla(0,0%,0%,.2);
  background-image: -webkit-radial-gradient( hsla(200,100%,90%,1) 0%, hsla(200,100%,70%,1) 15%, hsla(200,100%,60%,.3) 28%, hsla(200,100%,30%,0) 70% );
  background-repeat: no-repeat;
  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
  outline: none;
}

.checkHost:checked {
  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
}

.checkHost:active {
  -webkit-transform: scale(1.5);
  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
}



/* The up/down direction logic */

.checkHost,
.checkHost:active {
  background-position: 0 24px;
}

.checkHost:checked {
  background-position: 0 0;
}

.checkHost:checked ~ .checkHost,
.checkHost:checked ~ .checkHost:active {
  background-position: 0 -24px;
}

/*///////////*/


.checkHostWhite {
  -webkit-appearance: none;
 /* remove default */
  display: block;
  margin: 10px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  cursor: pointer;
  vertical-align: middle;
  box-shadow: hsla(0,0%,100%,.15) 0 1px 1px, inset hsla(0,0%,0%,.5) 0 0 0 1px;
  background-color: hsla(0, 4%, 86%, 0.2);
  background-image: -webkit-radial-gradient( rgb(3, 114, 170) 0%, rgba(4, 108, 160, 0.788) 15%, rgba(5, 108, 160, 0.651) 28%, hsla(200,100%,30%,0) 70% );
  background-repeat: no-repeat;
  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
  outline: none;
}

.checkHostWhite:checked {
  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
}

.checkHostWhite:active {
  -webkit-transform: scale(1.5);
  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
}



/* The up/down direction logic */

.checkHostWhite,
.checkHostWhite:active {
  background-position: 0 24px;
}

.checkHostWhite:checked {
  background-position: 0 0;
}

.checkHostWhite:checked ~ .checkHostWhite,
.checkHostWhite:checked ~ .checkHostWhite:active {
  background-position: 0 -24px;
}
  /* **************************** horizontal Movil****************************** */
  @media (min-width: 500px) and (max-width: 900px) {
    .mainInfoMarker{
      width: 200%;;
    }
    
  }
  
/* ****************************Movil****************************** */
@media (max-width: 500px) {
  .mainInfoMarker{
    width: 300%;;
  }
  }
  

`, "",{"version":3,"sources":["webpack://./src/components/styles/InfoMarker.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;;AAEZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;;AAEb;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,4EAA4E;EAC5E,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;;AAGA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB;;iBAEe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,QAAQ;EACR,MAAM;EACN,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB;;iBAEe;EACf,cAAc;EACd,iBAAiB;EACjB,OAAO;EACP,MAAM;EACN,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B,EAAE,8CAA8C;AAChF,qBAAqB,EAAE,+CAA+C;AACtE,UAAU,EAAE,kDAAkD;AAC9D,SAAS;AACT;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B,EAAE,8CAA8C;AAChF,qBAAqB,EAAE,+CAA+C;AACtE,UAAU,EAAE,kDAAkD;AAC9D,SAAS;AACT;AACA;EACE,yEAAyE;EACzE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,yEAAyE;EACzE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sDAAsD;EACtD,+CAA+C;EAC/C,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,sDAAsD;EACtD,oCAAoC;EACpC,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,gBAAgB,EAAE,oDAAoD;EACtE,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;;AAEb;AACA;EACE,WAAW;AACb;AACA;AACA,gBAAgB;AAChB,WAAW;AACX,gBAAgB;AAChB;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,UAAU;EACV,sBAAsB,EAAE,8CAA8C;EACtE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA,wFAAwF;AACxF;EACE,wBAAwB;CACzB,mBAAmB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,2EAA2E;EAC3E,kCAAkC;EAClC,mJAAmJ;EACnJ,4BAA4B;EAC5B;oDACkD;EAClD,aAAa;AACf;;AAEA;EACE;oDACkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;;;AAIA,gCAAgC;;AAEhC;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,cAAc;;;AAGd;EACE,wBAAwB;CACzB,mBAAmB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,2EAA2E;EAC3E,uCAAuC;EACvC,sJAAsJ;EACtJ,4BAA4B;EAC5B;oDACkD;EAClD,aAAa;AACf;;AAEA;EACE;oDACkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;;;AAIA,gCAAgC;;AAEhC;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;EACE,gFAAgF;EAChF;IACE;MACE,WAAW;IACb;;EAEF;;AAEF,oEAAoE;AACpE;EACE;IACE,WAAW;EACb;EACA","sourcesContent":["\r\n.mainInfoMarker{\r\n  display: flex;\r\n  position: relative;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.mainInfoMarkerWhite{\r\n  display: flex;\r\n  position: relative;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #fff;\r\n  /* border: 1px solid #003757; */\r\n}\r\n.contInfoMarker{\r\n  display: block;\r\n  position: relative;\r\n  width: 98%;\r\n  height: 98%;\r\n}\r\n.titleInfoMarker{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 10%;\r\n  max-height: 30px;\r\n}\r\n\r\n.bodyInfoMarker{\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height:50%;\r\n  \r\n}\r\n.actionsInfoMarker{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 40%;\r\n  \r\n}\r\n.txtTitleInfoMarker{\r\n  font-size: var(--font-size-med);\r\n  color: var(--main-color);\r\n}\r\n.txtTitleInfoMarkerWhite{\r\n  font-size: medium;\r\n  color: #003757;\r\n}\r\n.contHost{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 50%;\r\n}\r\n.contCheck{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 5%;\r\n  height: 100%;\r\n}\r\n.contInfoHost{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 95%;\r\n  height: 100%;\r\n}\r\n.infoHost{\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 60%;\r\n  border: var(--border-table-color) 1px solid;\r\n  border-radius: var(--border-radios-small);\r\n}\r\n.rowInfo {\r\n  justify-content: center;\r\n  position: relative;\r\n  display: flex;\r\n  overflow: hidden;\r\n  height: 60%;\r\n  /* background: #5d5c69; */\r\n  background-color: var(--white-color);\r\n  /* background-size: 400%; */\r\n  color: var(--txt-color);\r\n  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);\r\n  width: 100%;\r\n}\r\n.rowInfoWhite {\r\n  justify-content: center;\r\n  position: relative;\r\n  display: flex;\r\n  overflow: hidden;\r\n  height: 60%;\r\n  /* background: #5d5c69; */\r\n  background-color: #eeeeee;\r\n  background-size: 400%;\r\n  color: #003757;\r\n  border-radius: 0px 0px 10px 10px;\r\n  width: 100%;\r\n}\r\n.titlesInfo{\r\n  height: 40%;\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: var(--third-color);\r\n  /* max-height: 25px; */\r\n}\r\n.titlesInfoWhite{\r\n  height: 40%;\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #003757;\r\n  /* max-height: 25px; */\r\n}\r\n.hostInfoCell{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n.txtHostInfoCell{\r\n  text-align: center;\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n  word-break: break-all;\r\n  margin: 0 0 1em 1em;\r\n  display: flex;\r\n  font-size: var(--font-size-xSmall);\r\n  letter-spacing: 0.5px;\r\n  justify-content: center;\r\n  margin: 2%;\r\n}\r\n.textWOA{\r\n  font-size: var(--font-size-med);\r\n  color: var(--txt-color-low);\r\n}\r\n.textWOAWhite{\r\n  font-size: medium;\r\n  color: #00375771;\r\n  font-weight: unset !important;\r\n}\r\n\r\n\r\n/*************************************cont actions**************************************/\r\n.txtHostSelected{\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  /* align-items: center;\r\n  width: 30%;\r\n  height: 100%; */\r\n  color: var(--main-color);\r\n  font-size: var(--font-size-small);\r\n  /* font-weight: bold; */\r\n  left: 2%;\r\n  top: 0;\r\n  /* background-color: rgb(23, 24, 24); */\r\n}\r\n.txtHostSelectedWhite{\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  /* align-items: center;\r\n  width: 30%;\r\n  height: 100%; */\r\n  color: #003757;\r\n  font-weight: bold;\r\n  left: 0;\r\n  top: 0;\r\n  /* background-color: rgb(23, 24, 24); */\r\n}\r\n.contActionsInfoMarker{\r\n  position: relative;\r\n  display: block;\r\n  width: 99%;\r\n  height: 98%;\r\n  /* border: #ffffff33 1px solid; */\r\n}\r\n.menu-actions{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: right;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 15%;\r\n}\r\n.compactactions-list{\r\n  position: relative;\r\n  display: flex;\r\n  width: 30%;\r\n  height: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  justify-content: space-between; /* Distribuye el espacio entre los elementos */\r\nlist-style-type: none; /* Elimina los estilos de viñetas de la lista */\r\npadding: 0; /* Elimina el relleno predeterminado de la lista */\r\nmargin: 0; \r\n}\r\n.compactactions-listWhite{\r\n  position: relative;\r\n  display: flex;\r\n  width: 30%;\r\n  height: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  justify-content: space-between; /* Distribuye el espacio entre los elementos */\r\nlist-style-type: none; /* Elimina los estilos de viñetas de la lista */\r\npadding: 0; /* Elimina el relleno predeterminado de la lista */\r\nmargin: 0; \r\n}\r\n.compactactions-list li {\r\n  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n  width: 33%;\r\n  height: 100%;\r\n  background-color: transparent;\r\n  border-right: 1px solid var(--border-table-color);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  cursor: pointer;\r\n  /* color: rgba(195,195,195,1); */\r\n  color: var(--txt-color);\r\n}\r\n.compactactions-listWhite li {\r\n  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n  width: 33%;\r\n  height: 100%;\r\n  background-color: transparent;\r\n  border-right: 1px solid #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: small;\r\n  cursor: pointer;\r\n  /* color: rgba(195,195,195,1); */\r\n  color: #003757;\r\n}\r\n.compactactions-listWhite li:hover{\r\n  background-color: rgba(179, 179, 179, 0.534);\r\n}\r\n.action-selected{\r\n  /* background-color: rgba(195,195,195,1) !important; */\r\n  background-color: var(--third-color) !important;\r\n  /* color: rgb(1, 17, 31) !important; */\r\n  color:var(--white-color) !important;\r\n}\r\n.action-selectedWhite{\r\n  /* background-color: rgba(195,195,195,1) !important; */\r\n  background-color: #003757 !important;\r\n  /* color: rgb(1, 17, 31) !important; */\r\n  color:aliceblue !important;\r\n}\r\n.contActions{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 85%;\r\n  border: var(--border-table-color) 1px solid;\r\n  border-radius: var(--border-radios-small);\r\n}\r\n.contActionsWhite{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 85%;\r\n  border: #003757 2px solid;\r\n}\r\n.contAcciones{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 90%;\r\n  height: 80%;\r\n}\r\n\r\n.lblInfoHost{\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 0;\r\n  top: 0;\r\n  color: aliceblue;\r\n  margin-left: 1%;\r\n}\r\n.lblInfoHostWhite{\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 0;\r\n  top: 0;\r\n  color: 003757;\r\n  margin-left: 1%;\r\n}\r\n.menuActionDataIM {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  /* max-width: 400px;  */\r\n  width: 95%;\r\n  overflow-y: auto; /* Activar el scroll vertical cuando sea necesario */\r\n  max-height: 95%;\r\n  height: 85%;\r\n}\r\n.menuActionCellIM .compactAction{\r\n  width: 90%;\r\n  height: 70%;\r\n  \r\n}\r\n.menuActionCellIM .menuActionOption{\r\n  height: 90%;\r\n}\r\n.oneCell{\r\nmax-width: 150px;\r\nheight: 50%;\r\nmax-height: 50px;\r\n}\r\n.menuActionCellIM {\r\n  /* border: unset; */\r\n  border: 1px solid rgba(240, 248, 255, 0.105);\r\n  width: 25%;\r\n  box-sizing: border-box; /* Considerar el padding y borde en el ancho */\r\n  /* min-height: 50%; */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 50%;\r\n}\r\n/******************************estilos de radiocheck************************************/\r\n.checkHost {\r\n  -webkit-appearance: none;\r\n /* remove default */\r\n  display: block;\r\n  margin: 10px;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  box-shadow: hsla(0,0%,100%,.15) 0 1px 1px, inset hsla(0,0%,0%,.5) 0 0 0 1px;\r\n  background-color: hsla(0,0%,0%,.2);\r\n  background-image: -webkit-radial-gradient( hsla(200,100%,90%,1) 0%, hsla(200,100%,70%,1) 15%, hsla(200,100%,60%,.3) 28%, hsla(200,100%,30%,0) 70% );\r\n  background-repeat: no-repeat;\r\n  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),\r\n    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);\r\n  outline: none;\r\n}\r\n\r\n.checkHost:checked {\r\n  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),\r\n    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n.checkHost:active {\r\n  -webkit-transform: scale(1.5);\r\n  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n\r\n\r\n/* The up/down direction logic */\r\n\r\n.checkHost,\r\n.checkHost:active {\r\n  background-position: 0 24px;\r\n}\r\n\r\n.checkHost:checked {\r\n  background-position: 0 0;\r\n}\r\n\r\n.checkHost:checked ~ .checkHost,\r\n.checkHost:checked ~ .checkHost:active {\r\n  background-position: 0 -24px;\r\n}\r\n\r\n/*///////////*/\r\n\r\n\r\n.checkHostWhite {\r\n  -webkit-appearance: none;\r\n /* remove default */\r\n  display: block;\r\n  margin: 10px;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  box-shadow: hsla(0,0%,100%,.15) 0 1px 1px, inset hsla(0,0%,0%,.5) 0 0 0 1px;\r\n  background-color: hsla(0, 4%, 86%, 0.2);\r\n  background-image: -webkit-radial-gradient( rgb(3, 114, 170) 0%, rgba(4, 108, 160, 0.788) 15%, rgba(5, 108, 160, 0.651) 28%, hsla(200,100%,30%,0) 70% );\r\n  background-repeat: no-repeat;\r\n  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),\r\n    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);\r\n  outline: none;\r\n}\r\n\r\n.checkHostWhite:checked {\r\n  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),\r\n    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n.checkHostWhite:active {\r\n  -webkit-transform: scale(1.5);\r\n  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n\r\n\r\n/* The up/down direction logic */\r\n\r\n.checkHostWhite,\r\n.checkHostWhite:active {\r\n  background-position: 0 24px;\r\n}\r\n\r\n.checkHostWhite:checked {\r\n  background-position: 0 0;\r\n}\r\n\r\n.checkHostWhite:checked ~ .checkHostWhite,\r\n.checkHostWhite:checked ~ .checkHostWhite:active {\r\n  background-position: 0 -24px;\r\n}\r\n  /* **************************** horizontal Movil****************************** */\r\n  @media (min-width: 500px) and (max-width: 900px) {\r\n    .mainInfoMarker{\r\n      width: 200%;;\r\n    }\r\n    \r\n  }\r\n  \r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  .mainInfoMarker{\r\n    width: 300%;;\r\n  }\r\n  }\r\n  \r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
